/* eslint-disable import/order */
/* eslint-disable prettier/prettier */
import { routes } from '@bvi/admin-panel/api-routes';
import {
  apiContainer,
  getListTag,
  TagTypes,
} from '@bvi/admin-panel/shared/api';
import { ManageBaseDataKeys } from '@bvi/api-interfaces/entity/manage-base';
import { getResponseDataOrEmptyArray } from '@bvi/api-interfaces/response';
import { IManageListStatsResponse } from '@bvi/api-interfaces/response/manage-base-data';

export const manageListStatsApi = apiContainer.injectEndpoints({
  endpoints: (builder) => ({
    getManageListStats: builder.query<
      IManageListStatsResponse,
      ManageBaseDataKeys
    >({
      query: (type) => ({
        url: routes.manageList.stats(),
        method: 'GET',
        params: { type },
      }),
      providesTags: [getListTag(TagTypes.CASE_STATISTICS)],
    }),
  }),
});

export const { useGetManageListStatsQuery } = manageListStatsApi;

export const selectManageListStatsMap = (
  response?: IManageListStatsResponse,
): Record<number, { caseCount: number; claimantCount: number; averageSettlement: number }> => {
  const rows = getResponseDataOrEmptyArray(response);

  return Object.fromEntries(
    rows.map((row) => [
      row.id,
      {
        caseCount: row.caseCount,
        claimantCount: row.claimantCount,
        averageSettlement: row.averageSettlement,
      },
    ]),
  );
};
